// Client mirror of the server account-password policy
// (apps/api/src/lib/password-policy.ts). Kept in sync BY HAND — both are
// tiny and pure. The server is authoritative; this copy only drives live
// UI feedback so the operator isn't surprised by a 400.

export interface PasswordRule {
  key: "length" | "lower" | "upper" | "digit" | "symbol";
  label: string;
  test: (pw: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { key: "length", label: "mínimo 12 caracteres", test: (p) => p.length >= 12 },
  { key: "lower", label: "una minúscula", test: (p) => /[a-z]/.test(p) },
  { key: "upper", label: "una mayúscula", test: (p) => /[A-Z]/.test(p) },
  { key: "digit", label: "un número", test: (p) => /[0-9]/.test(p) },
  { key: "symbol", label: "un símbolo", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function passwordMeetsPolicy(pw: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(pw));
}
